import { render } from "./up2_bom_show_email.vue?vue&type=template&id=0cc70a8b&scoped=true"
import script from "./up2_bom_show_email.vue?vue&type=script&lang=js"
export * from "./up2_bom_show_email.vue?vue&type=script&lang=js"

import "./up2_bom_show_email.vue?vue&type=style&index=0&id=0cc70a8b&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc70a8b"]])

export default __exports__